import styled from "@emotion/styled";

import { fontRobotoCondensed, theme } from "shared/lib/styles";

export const Container = styled.div`
  position: relative;

  display: flex;
  flex-direction: column;
  gap: 24px;

  inline-size: 335px;
  margin-block: 0;
  margin-inline: auto;

  ${theme.breakpoints.up("tablet")} {
    margin-inline: 0;
  }

  ${theme.breakpoints.up("desktop")} {
    inline-size: 300px;
  }
`;

export const Title = styled.div`
  padding-block-end: 8px;

  font-weight: 700;
  font-size: 14px;
  font-family: ${fontRobotoCondensed};
  line-height: 16px;
  text-transform: uppercase;

  border-block-end: 1px solid #dddddd;
`;
